module.exports = __webpack_public_path__ + "static/hr.cb09e50a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/resume/hr.png
// module id = 475
// module chunks = 114276838955818